export default {"src":"/_next/static/media/ecommerceLogo6.f928e15d.svg","height":36,"width":260,"blurWidth":0,"blurHeight":0};